// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"485":"05b5348f","578":"416cb7bf"}[chunkId] + ".js";
};